import { UIHoverActionController } from './UIHoverActionController.ts';
import { MechanicValidatorShipMove } from '@colonist/game-mechanic-validators';
import { PlayerColor } from '@colonist/game-states';
import { logError } from '../../ui_utils/Utils.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { Sprites } from '../UIGameSprites.ts';
export class UIMoveShipHoverActionController extends UIHoverActionController {
    updateState() {
        const canMoveShip = this.validatorShipMove.canPlayerMoveShip(this.uiGameManager.gameController.myColor);
        this.updateHoverLocations(canMoveShip.validHoverLocations, canMoveShip.canTakeAction);
        this.uiGameManager.mapController.hoverController.onHoverStateChange();
    }
    getTexture(index) {
        return UIMoveShipHoverActionController.getMoveShipTextureForColor(this.uiGameManager.gameController.myColor, this.uiGameManager.gameController.isPlayerSpectator);
    }
    static getMoveShipTextureForColor(playerColor, isSpectator) {
        if (isSpectator) return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_green);
        switch(playerColor){
            case PlayerColor.Blue:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_blue);
            case PlayerColor.Red:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_red);
            case PlayerColor.Orange:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_orange);
            case PlayerColor.Green:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_green);
            case PlayerColor.Bronze:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_bronze);
            case PlayerColor.Silver:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_silver);
            case PlayerColor.Gold:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_gold);
            case PlayerColor.Black:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_black);
            case PlayerColor.Purple:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_purple);
            case PlayerColor.MysticBlue:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_mysticblue);
            case PlayerColor.White:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_white);
            case PlayerColor.Pink:
                return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_pink);
            case PlayerColor.None:
                break;
        }
        logError('getMoveShipTextureForColor', [
            playerColor
        ]);
        return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ship_move_green);
    }
    // eslint-disable-next-line class-methods-use-this
    getBankActionAmount(index) {
        return undefined;
    }
    constructor(uiGameManager, shipState, pirateState){
        super(uiGameManager);
        this.resources = [];
        this.action = (index)=>this.uiGameManager.socketGameSend.selectedShipToMove(index);
        this.uiGameManager.mapController.hoverController.registerTileEdgeHoverAction(this);
        this.shouldHideOnSpecialBuildPhase = true;
        this.validatorShipMove = new MechanicValidatorShipMove(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, shipState, pirateState);
    }
}
